import { render, staticRenderFns } from "./WorkGeneralInformation.vue?vue&type=template&id=3098f014&scoped=true&"
import script from "./WorkGeneralInformation.vue?vue&type=script&lang=js&"
export * from "./WorkGeneralInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3098f014",
  null
  
)

export default component.exports